// © Microsoft Corporation. All rights reserved.

import { Activities } from "@msnews/social-data-service";
import NotificationCard from "./NotificationCard";
import React from "react";
import { SocialLocalizedStrings } from "../../Social.localizedStrings";
import { SocialProps } from "../../Social.props";
import { SocialState } from "../../Social.state";
import { classNames } from "@microsoft/fast-web-utilities";
import { connect } from "react-redux";

export interface NotificationTrayProps extends SocialProps {
    notifications: Activities;
    t: SocialLocalizedStrings;
    alignment?: "left" | "right";
}

const mapStateToProps = function(state: SocialState) {
    return {
        me: state.me,
        notifications: state.notifications,
        theme: state.theme
    };
};

export class NotificationTray extends React.Component<NotificationTrayProps> {
    fetchNotificationsJobId: NodeJS.Timer;

    constructor(props) {
        super(props);
    }

    componentDidMount() {
        this.props.usersConnector.fetchNotifications();
        this.fetchNotificationsJobId = setInterval(() => { this.props.usersConnector.fetchNotifications(); }, 30000);
    }

    componentWillUnmount() {
        clearInterval(this.fetchNotificationsJobId);
    }

    render() {
        const { alignment, componentConnector, t, managedClasses, users, usersConnector, market, me, notifications, theme, mainTelemetryObject } = this.props;
        if (!notifications) { return null; }
        const isLeftAligned = alignment == "left";

        return (
            <div className={classNames(
                managedClasses.notificationTrayContainer,
                [managedClasses.notificationTrayContainerRightAligned, !isLeftAligned],
                [managedClasses.notificationTrayContainerLeftAligned, isLeftAligned]
            )} role="dialog" aria-label={t.AriaLabelsNotificationTray}>
                {notifications.list.map(notification => {
                    return <NotificationCard key={notification.id} {...{componentConnector, usersConnector, users, notification, managedClasses, me, t, market, theme, mainTelemetryObject}}/>;
                })}
            </div>
        );
    }
}
export default connect(mapStateToProps)(NotificationTray);